import React from "react";
import ThemeColorsForm from "./forms/ThemeColorsForm";
import { isEmpty } from "lodash";

export default class ThemeColorsFormDiv extends React.Component {
  render() {
    const theme_colors = isEmpty(this.props.data.website_theme)
      ? {
          text_color: "",
          highlighted_text_color: "",
          button_color: "",
          button_text_color: "",
          link_text_color: "",
          background_color: "",
          icon_color: "",
          top_navigation_button_color: "",
          top_navigation_button_text_color: "",
          category_header_text_color: "",
          homepage_icon_color: "",
          homepage_button_color: "",
          homepage_button_text_color: "",
          homepage_highlighted_text_color: "",
        }
      : this.props.data.website_theme;
    return (
      <>
        <ThemeColorsForm
          {...this.props}
          values={theme_colors}
          onSubmit={this.props.onSubmitThemeColorsForm}
        />
      </>
    );
  }
}
